import type { ContactSubjectValue } from "./contactSubjects";
import { CONTACT_SUBJECT_VALUES } from "./contactSubjects";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string): boolean => EMAIL_PATTERN.test(email.trim());

export const isContactSubjectValue = (value: string): value is ContactSubjectValue =>
    (CONTACT_SUBJECT_VALUES as readonly string[]).includes(value);

export type ContactFormValues = {
    subject: string;
    email: string;
    body: string;
};

export type ContactFieldName = "subject" | "email" | "body";

export type ContactFieldErrorCode =
    | "subject_required"
    | "email_required"
    | "email_invalid"
    | "message_required"
    | "message_min_length";

export const CONTACT_FIELD_ERROR_MESSAGE_KEYS: Record<ContactFieldErrorCode, string> = {
    subject_required: "contact.error.subject.required",
    email_required: "contact.error.email.required",
    email_invalid: "contact.error.email.invalid",
    message_required: "contact.error.message.required",
    message_min_length: "contact.error.message.min_length",
};

export const getContactFieldErrors = (
    values: ContactFormValues,
): Partial<Record<ContactFieldName, ContactFieldErrorCode>> => {
    const errors: Partial<Record<ContactFieldName, ContactFieldErrorCode>> = {};

    if (!isContactSubjectValue(values.subject)) {
        errors.subject = "subject_required";
    }

    const trimmedEmail = values.email.trim();
    if (!trimmedEmail) {
        errors.email = "email_required";
    } else if (!isValidEmail(values.email)) {
        errors.email = "email_invalid";
    }

    const trimmedBody = values.body.trim();
    if (!trimmedBody) {
        errors.body = "message_required";
    } else if (trimmedBody.length < 3) {
        errors.body = "message_min_length";
    }

    return errors;
};

export const isContactFormValid = (values: ContactFormValues): boolean =>
    Object.keys(getContactFieldErrors(values)).length === 0;
